import { render, staticRenderFns } from "./Edit_material.vue?vue&type=template&id=ad65940e&"
import script from "./Edit_material.vue?vue&type=script&lang=js&"
export * from "./Edit_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports